import type { EffectivePrintTemplate, PrintInventoryType, PrintTemplate } from '@repo/types';
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';

/** Modèles de fiche d'impression de l'organisation : lecture pour tous, édition pour les responsables. */
export class PrintTemplatesService {
  constructor(private readonly axios: AxiosInstance = axiosInstance) {}

  /** Modèle applicable à l'organisation de l'utilisateur ; `config: null` = fiche par défaut. */
  async effective(type: PrintInventoryType): Promise<EffectivePrintTemplate> {
    const { data } = await this.axios.get(ENDPOINTS.PRINT_TEMPLATES.EFFECTIVE(type));
    return data.data;
  }

  /** Enregistre le modèle ; `expectedRevision` = révision chargée dans l'éditeur (409 si quelqu'un d'autre a enregistré entre-temps). */
  async save(type: PrintInventoryType, config: PrintTemplate, expectedRevision: number): Promise<EffectivePrintTemplate> {
    const { data } = await this.axios.put(ENDPOINTS.PRINT_TEMPLATES.ADMIN(type), { config, expectedRevision });
    return data.data;
  }

  /** Revient à la fiche par défaut pour toute l'organisation. */
  async reset(type: PrintInventoryType): Promise<void> {
    await this.axios.delete(ENDPOINTS.PRINT_TEMPLATES.ADMIN(type));
  }
}

export const printTemplatesService = new PrintTemplatesService();
